export function init(){
    initGoogleServices()
}
async function initGoogleServices(){
    loadGoogleScript();
    
    // listeners
    $(document).on('click', '.gmail-thread', function(){
        maybeInitLogin('get-thread', {
            'thread_id': $(this).data('thread-id')
        });
    });
    $(document).on('click', '#modal-calendar .btn-close', function(){
        resetModalCalendar();
    });
    $(document).on('click', '#modal-email .btn-close', function(){
        resetModalEmail();
    });
    $(document).on('click', '#modal-sms .btn-close', function(){
        resetModalSms();
    });
    $(document).on('click', '.add-attendee-email', function(){
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let email =  $('[name="attendee-email"]').val();
        if(regex.test(email)){
            $('.container-list-attendees').append('<div class="attendee-email-elem"><div class="remove-attendee-email me-2">x</div><span>' + email + '</span></div>');
            $('[name="attendee-email"]').val('');
        } else {
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'L\'email inserita non è corretta, si prega di controllare eventuali errori di battitura',
                icon: 'error',
            });
        }
    });
    $(document).on('click', '.remove-attendee-email', function(){
        $(this).parent().remove();
    });
    $(document).on('change', '[name="toggle-type-event"]', function(e){
        if(e.target.checked){
            $('.event-location-option').addClass('d-none');
            $('.event-hangout-option').removeClass('d-none');
            $('[name="location"]').val('');
        } else {
            $('.event-location-option').removeClass('d-none');
            $('.event-hangout-option').addClass('d-none');
            $('.container-list-attendees').html('');
            $('[name="attendee-email"]').val('');
        }
    });
    $(document).on('click', '#modal-calendar .btn-backend-delete', function(){ 
        Swal.fire({
            title: 'Vuoi eliminare il seguente evento?',
            showCancelButton: true,
            confirmButtonText: 'Continua',
            cancelButtonText: 'Annulla',
            icon: 'question',
            heightAuto: false,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                deleteEvent({"event_id": $('input[name="event_id"]').val()});
            }
        })
    });
    $(document).on('click', '#modal-calendar .btn-backend', function(){
        $('.form-loader').removeClass('d-none');
        if($('[name="start_date"]').val() == ''){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, non è stata inserita la data di inizio',
                icon: 'error',
            });
            $('.form-loader').addClass('d-none');
            return 0;
        }
        if($('[name="end_date"]').val() == ''){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, non è stata inserita la data di fine',
                icon: 'error',
            });
            $('.form-loader').addClass('d-none');
            return 0;
        }
        var event = {
            'summary': $('input[name="summary"]').val(),
            'description': $('[name="description"]').val(),
            'reminders': {
                'useDefault': false,
                'overrides': [
                    {'method': 'email', 'minutes': $('[name="value_email_reminder"]').val() * $('[name="unit_email_reminder"]').val()},
                    {'method': 'popup', 'minutes': $('[name="value_popup_reminder"]').val() * $('[name="unit_popup_reminder"]').val()}
                ]
            },
            'start': {
                'dateTime': new Date([$('[name="start_date"]').val(), $('[name="start_time"]').val()]).toISOString(),
                'timeZone': 'Europe/Rome'
            },
            'end': {
                'dateTime': new Date([$('[name="end_date"]').val(), $('[name="end_time"]').val()]).toISOString(),
                'timeZone': 'Europe/Rome'
            },
        };
        if($('[name="toggle-type-event"]').is(':checked')){
            if($('.attendee-email-elem span').length == 0){
                Swal.fire({
                    title: 'Attenzione',
                    text: 'Si sta cercando di creare una riunione digitale senza invitati, vuoi proseguire ugualmente?',
                    showCancelButton: true,
                    confirmButtonText: 'Continua',
                    cancelButtonText: 'Annulla',
                    icon: 'warning',
                    heightAuto: false,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        event.attendees = [];
                        $('.attendee-email-elem span').each(function(){
                            event.attendees.push({'email': $(this).text()});
                        })

                        event.conferenceData = {
                            'createRequest': {
                                'conferenceSolutionKey': {
                                    'type': 'hangoutsMeet'
                                },
                                'requestId': (Math.random() + 1).toString(36).substring(7)
                            }
                        };
                        if($('input[name="event_id"]').val()){
                            updateEvent({ "event" : event, "event_id" : $('input[name="event_id"]').val()});
                        } else {
                            addEvent(event);
                        }
                    } else {
                        $('.form-loader').addClass('d-none');
                        return
                    }
                })
            } else {
                event.attendees = [];
                $('.attendee-email-elem span').each(function(){
                    event.attendees.push({'email': $(this).text()});
                })

                event.conferenceData = {
                    'createRequest': {
                        'conferenceSolutionKey': {
                            'type': 'hangoutsMeet'
                        },
                        'requestId': (Math.random() + 1).toString(36).substring(7)
                    }
                };
                if($('input[name="event_id"]').val()){
                    updateEvent({ "event" : event, "event_id" : $('input[name="event_id"]').val()});
                } else {
                    addEvent(event);
                }
            }
        } else {
            event.location = $('input[name="location"]').val();
            if($('input[name="event_id"]').val()){

                updateEvent({ "event" : event, "event_id" : $('input[name="event_id"]').val()});
            } else {
                addEvent(event);
            }
        }
    });
    if($('#location').length > 0){
        autocomplete('location');
    }
}
function loadGoogleScript(){
    loadScript("https://apis.google.com/js/api.js", gapiLoaded);
    loadScript("https://accounts.google.com/gsi/client", gisLoaded);
}
function loadScript(src, callback) {
    let script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = script.onreadystatechange = function() {
        callback()
    };
    document.body.append(script);
}
function gapiLoaded() {
    gapi.load('client', initializeGapiClient);
}   
function gisLoaded() {
    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES
    });
    gisInited = true;
    maybeInitLogin('init');
}
async function initializeGapiClient() {
    await gapi.client.init({
        apiKey: API_KEY,
        discoveryDocs: DISCOVERY_DOC,
    });
    gapiInited = true;
    maybeInitLogin('init');
}
function maybeInitLogin(action, data = {}){
    if(gisInited && gapiInited){
        if(Cookies.get("gapi_token") === '' || Cookies.get("gapi_token") === undefined){
            tokenClient.callback = async (resp) => {
                Cookies.set("gapi_token", resp.access_token);
                $('#signin_button').addClass('d-none');
                $('#signout_button').removeClass('d-none');
                if (resp.error !== undefined) {
                  throw (resp);
                }
                maybeInitLogin(action, data);
            };
    
            if (gapi.client.getToken() === null) {
                // Prompt the user to select a Google Account and ask for consent to share their data
                // when establishing a new session.
                tokenClient.requestAccessToken({prompt: 'consent'});
            } else {
                // Skip display of account chooser and consent dialog for an existing session.
                tokenClient.requestAccessToken({prompt: ''});
            }
        } else {
            gapi.client.setToken({access_token: Cookies.get("gapi_token")});
            $('#signin_button').addClass('d-none');
            $('#signout_button').removeClass('d-none');
            switch(action){
                case 'send-email':
                    sendEmail(data);
                    break;
                case 'reply-email':
                    replyEmail(data);
                    break;
                case 'init-modal':
                    initCalendarModal(data);
                    break;
                case 'get-thread':
                    getThread(data);
                    break;
                case 'list-events':
                    listUpcomingEvents();
                    break;
                case 'add-event':
                    addEvent(data)
                    break;
                case 'update-event':
                    updateEvent(data);
                    break;
                case 'delete-event':
                    deleteEvent(data);
                    break;
                case 'get-event':
                    setupModalEvent(data);
                    break;
                default:
                    $(document).trigger('google-auth-granted');
                    break;
            }
        }
    }
}

// GMAIL FUNCTIONS 
// export async function listThreads() {
//     let response;
//     try {
//         response = await gapi.client.gmail.users.threads.list({
//             'userId': 'me'
//         });
//     } catch (err) {
//         Cookies.set("gapi_token", "");
//         maybeInitLogin('list-threads');
//         return;
//     }
//     const threads = response.result.threads;
//     if (!threads || threads.length == 0) {
//       document.getElementById('emails-container').innerText = 'No threads found.';
//       return;
//     }
//     for(let thread of threads){
//         $('#emails-container').append('<div class="gmail-thread" data-thread-id="' + thread.id + '">' + thread.snippet + '</div>');
//     }
// }
export async function getThread(data) {
    let threadId = data.threadId;
    let response;
    try {
        response = await gapi.client.gmail.users.threads.get({
            'id': threadId,
            'userId': 'me',
        });
        if(response.status == 200){
            getThreadMessage(response.result.messages);
        }
    } catch (err) {
        if(data.try && err.status == 401){
            data.try = false;
            Cookies.set("gapi_token", "");
            maybeInitLogin('get-thread', data);
        } else {
            return 0;
        }
    }
}
export async function sendEmail(data){
    try {
        $('.form-loader').removeClass('d-none');
        if(data.subject == '' || data.to == '' || data.body == ''){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, non sono stati inseriti i dati richiesti',
                icon: 'error',
            });
            $('.form-loader').addClass('d-none');
            return 0;
        }

        const subject = data.subject;
        const utf8Subject = `=?utf-8?B?${Buffer.from(subject).toString('base64')}?=`;
        const messageParts = [
            // 'From: my Alias <federico.brunello@mydonor.it>',
            'To: ' + data.to,
            'Content-Type: text/html; charset=utf-8',
            'MIME-Version: 1.0',
            `Subject: ${utf8Subject}`,
            '',
            data.body,
        ];
        const message = messageParts.join('\n');

        // The body needs to be base64url encoded.
        const encodedMessage = Buffer.from(message)
            .toString('base64')
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

        const response = await gapi.client.gmail.users.messages.send({
            userId: 'me',
            resource: {
                raw: encodedMessage
            }
        });

        if(response.status == "200"){
            const msg = await gapi.client.gmail.users.messages.get({
                userId: 'me',
                id: response.result.id
            });
            for(let header of msg.result.payload.headers){
                if(header.name == 'To'){
                    data.to = header.value;
                }
                if(header.name == 'From'){
                    data.from = header.value;
                }
                if(header.name == 'Subject'){
                    data.subject = header.value;
                }
            }
            data.internalDate = msg.result.internalDate;
            createThreadEmail(response.result.id, response.result.threadId, data);
        }
        return true;
    } catch (err) {
        $('.form-loader').addClass('d-none');
        if(err.status == 401){
            Cookies.set("gapi_token", "");
            maybeInitLogin('send-email', data);
        } else if(err.status == 400){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, controlla di aver inserito i dati corretti',
                icon: 'error',
            });
        }
        return;
    }
}

export async function replyEmail(data){
    try {
        if(data.threadId == '' || data.body == ''){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, non sono stati inseriti i dati richiesti',
                icon: 'error',
            });
            $('.form-loader').addClass('d-none');
            return 0;
        }

        const msg = await gapi.client.gmail.users.messages.get({
            userId: 'me',
            id: data.threadId
        });

        let to;
        let subject;
        for(let header of msg.result.payload.headers){
            if(header.name == 'To'){
                to = header.value;
            }
            if(header.name == 'Subject'){
                subject = header.value;
            }
        }

        const utf8Subject = `=?utf-8?B?${Buffer.from(subject).toString('base64')}?=`;
        const messageParts = [
            'To: ' + to,
            'Content-Type: text/html; charset=utf-8',
            'MIME-Version: 1.0',
            `Subject: ${utf8Subject}`,
            '',
            data.body,
        ];
        const message = messageParts.join('\n');

        // The body needs to be base64url encoded.
        const encodedMessage = Buffer.from(message)
            .toString('base64')
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

        const response = await gapi.client.gmail.users.messages.send({
            userId: 'me',
            resource: {
                threadId: data.threadId,
                raw: encodedMessage
            }
        });

        if(response.status == "200"){
            location.reload();
            
            const msg = await gapi.client.gmail.users.messages.get({
                userId: 'me',
                id: response.result.id
            });

            let subject;
            let from;
            let to;
            for(let header of msg.result.payload.headers){
                if(header.name == 'To'){
                    to = header.value;
                }
                if(header.name == 'From'){
                    from = header.value;
                }
                if(header.name == 'Subject'){
                    subject = header.value;
                }
            }
            let html_snippet = '';
            let encoded = 'N';
            if(msg.result.payload.headers.parts){
                for(let part of msg.result.payload.headers.parts){
                    if(part.mimeType == 'text/html'){
                        html_snippet = part.body.data;
                        encoded = 'S';
                    }
                }
            }
            let snippet = html_snippet != '' ? html_snippet :  msg.result.snippet;

            let data = {
                'thread-id': msg.result.threadId,
                'email-id':  msg.result.id,
                'email_subject': subject,
                'email_to': to,
                'email_from': from,
                'email_body': snippet,
                'internal_date':  msg.result.internalDate,
                'encoded': encoded
            };
            $.ajax({
                url: '/ajax/upload-msg',
                method: 'POST',
                data: data,
                success: function(result){
                    if(result.success){
                        $('[data-thread-id="' + msg.result.threadId + '"] .email-list-container').append('<div class="single-msg mt-3" data-email-id="'+ msg.result.id +'"><div style="line-height: 1"><small>from: ' + from + '</small></div><div style="line-height: 1"><small>to: ' + to + '</small></div><div class="mt-2">' + result.html_snippet + '</div></div>');
                    }
                }
            })
        }
        return true;
    } catch (err) {
        $('.form-loader').addClass('d-none');
        if(err.status == 401){
            Cookies.set("gapi_token", "");
            maybeInitLogin('reply-email', data);
        } else if(err.status == 400){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'Non è stato possibile proseguire, controlla di aver inserito i dati corretti',
                icon: 'error',
            });
        }
        return;
    }
}

// CALENDAR FUNCTION
export async function listUpcomingEvents() {
    var calendarEl = document.getElementById('calendar');

    if(!calendarEl){
        return;
    }
    let response;
    try {
        const request = {
            'calendarId': 'primary',
            'timeMin': (new Date()).toISOString(),
            'showDeleted': false,
            'singleEvents': true,
            'maxResults': 10,
            'orderBy': 'startTime',
        };
        response = await gapi.client.calendar.events.list(request);
        $('#signout_button').removeClass('d-none');
        $('#signin_button').addClass('d-none');

    } catch (err) {
        $('#signout_button').addClass('d-none');
        $('#signin_button').removeClass('d-none');
        Cookies.set("gapi_token", "");
        maybeInitLogin('list-events');
        return;
    }
    $('#calendar').removeClass('calendar-no-google');
    $('#calendar').empty();

    const events = response.result.items;

    let calendar_events = [];
    for(let event of events){
        calendar_events.push({
            id: event.id,
            title: event.summary,
            start: event.start.dateTime,
            end: event.end.dateTime,
            editable: true
        });
    }
    var calendar = new FullCalendar.Calendar(calendarEl, {
        events: calendar_events,
        locale: 'it',
        eventClick: function(info) {
            info.jsEvent.preventDefault(); // don't let the browser navigate
            let eventId = info.event.id;
            setupModalEvent({ "event_id" : eventId })
        },
        selectable: true,
        select: function(jsEvent, view){
            initCalendarModal(jsEvent);
        }
    });
    calendar.render();
}

export function initCalendarModal(data){
   const accessToken = Cookies.get("gapi_token");
   try {
        let request = new XMLHttpRequest();
        const url = `https://www.googleapis.com/oauth2/v3/userinfo`;
        request.addEventListener("loadend", function() {
            const response = JSON.parse(this.responseText);
            if (this.status === 200) {
                resetModalCalendar();
                if(data.startStr){
                    $('input[name="start_date"]').val(data.startStr);
                }
                if(data.endStr){
                    var endDate = new Date(data.endStr);
                    endDate.setDate(endDate.getDate() - 1);
                    $('input[name="end_date"]').val(endDate.toISOString().split('T')[0]);
                }
                if(data.createHangout){
                    $('[name="toggle-type-event"]').prop('checked', true);
                    $('.event-hangout-option').removeClass('d-none');
                    $('.event-location-option').addClass('d-none');
                }
                if(response.email){
                    $('#organizzatore').val(response.email);
                    $('.container-organizer').text(response.email);
                }
                if(data.taskId){
                    $('[name="task_id"]').val(data.taskId);
                }
                $('.container-list-attendees').html('');
                $('[name="start_time"]').val('08:30');
                $('[name="end_time"]').val('17:30');
                $('#modal-calendar .form-title').text('Crea Evento');
                $('#modal-calendar .btn-backend').text('Salva');
                $('.btn-backend-delete').addClass('d-none');
                $('#modal-calendar').removeClass('opacity-0');
            } else {
                Cookies.set("gapi_token", "");
                maybeInitLogin('init-modal', data);
                return;
            }
        });

        request.open("GET", url, true);
        request.setRequestHeader('Authorization', `Bearer ${accessToken}`);
        request.send();
    } catch (err) {
        Cookies.set("gapi_token", "");
        maybeInitLogin('init-modal', data);
        return;
    }
}
function addEvent(new_event){
    try{
        const request = gapi.client.calendar.events.insert({
            'calendarId': 'primary',
            'conferenceDataVersion': 1,
            'sendNotifications': true,
            'resource': new_event
        });
        request.execute(function(event){
            if(event.error !== undefined){
                Cookies.set("gapi_token", "");
                maybeInitLogin('add-event', new_event);
                return;
            }
            insertEventMove(event.id, event.start.dateTime, event.end.dateTime, event.hangoutLink);
            $('#calendar').html('');
            $('.form-loader').addClass('d-none');
            $('#modal-calendar').addClass('opacity-0');
            listUpcomingEvents();
        });
    } catch (err) {
        Cookies.set("gapi_token", "");
        maybeInitLogin('add-event', new_event);
        return;
    }
}
async function updateEvent(data){
    let event = data.event;
    let eventId = data.event_id;
    try{
        const request = gapi.client.calendar.events.update({
            'calendarId': 'primary',
            'eventId': eventId,
            'resource': event
        });
        request.execute(function(event){
            
            if(event.error !== undefined){
                Cookies.set("gapi_token", "");
                maybeInitLogin('update-event', data);
                return;
            }
            updateEventMove(event.start.dateTime, event.end.dateTime, event.hangoutLink);
            $('#calendar').html('');
            $('.form-loader').addClass('d-none');
            $('#modal-calendar').addClass('opacity-0');
            listUpcomingEvents();
        });
    } catch (err) {
        Cookies.set("gapi_token", "");
        maybeInitLogin('update-event', data);
        return;
    }
} 
function deleteEvent(data){
    let eventId = data.event_id;
    try {
        const request = gapi.client.calendar.events.delete({
            'calendarId': 'primary',
            'eventId': eventId
        });
        request.execute(function(event){
            if(event.error !== undefined){
                Cookies.set("gapi_token", "");
                maybeInitLogin('delete-event', data);
                return;
            }
            cancelEventMove(eventId);
            $('#calendar').html('');
            $('.form-loader').addClass('d-none');
            $('#modal-calendar').addClass('opacity-0');
            listUpcomingEvents();
        });
    } catch (err) {
        Cookies.set("gapi_token", "");
        maybeInitLogin('delete-event', data);
        return;
    }
}
export async function setupModalEvent(data){
    let eventId = data.event_id;
    let moveId = data.move_id ? data.move_id : '';
    resetModalCalendar();
    try {
        const request = {
            'calendarId': 'primary',
            'eventId': eventId,
            'timeMin': (new Date()).toISOString(),
            'showDeleted': false,
            'singleEvents': true
        };

        let response = await gapi.client.calendar.events.get(request);
        if(response.result.status == 'cancelled'){
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'L\'evento selezionato è stato cancellato dal tuo calendario.',
                icon: 'error',
            });
            return
        }
        if(response.result.hangoutLink && response.result.attendees){
            $('.hangout-link').text(response.result.hangoutLink);
            $('.hangout-link').attr('href', response.result.hangoutLink);
            $('.hangout-link-container').removeClass('d-none');
            $('[name="toggle-type-event"]').prop('checked', true);
            $('.event-hangout-option').removeClass('d-none');
            $('.event-location-option').addClass('d-none');
            let attendees = '';
            for(let attendee of response.result.attendees){
                let color;
                switch(attendee.responseStatus){ 
                    case 'needsAction':
                        color = '#e29b0d';
                        break;
                    case 'declined':
                        color = '#ca3a3a';
                        break;
                    case 'tentative':
                        color = '#0d9f19';
                        break;
                    case 'accepted':
                        color = '#0d9f19';
                        break;
                }
                attendees += '<div class="p-2" style="color:' + color + '; background-color:' + color + '1a">' + attendee.email + '</div>';
                $('.container-list-attendees').append('<div class="attendee-email-elem"><div class="remove-attendee-email me-2">x</div><span>' + attendee.email + '</span></div>');
            }
            $('.container-attendes').html(attendees);
        }
        $('[name="move_id"]').val(moveId);
        $('[name="event_id"]').val(eventId);
        $('[name="summary"]').val(response.result.summary);
        $('[name="description"]').val(response.result.description);
        $('[name="location"]').val(response.result.location);
        $('[name="start_date"]').val(response.result.start.dateTime.split('T')[0]);
        $('[name="end_date"]').val(response.result.end.dateTime.split('T')[0]);
        $('[name="start_time"]').val(response.result.start.dateTime.split('T')[1].split('+')[0]);
        $('[name="end_time"]').val(response.result.end.dateTime.split('T')[1].split('+')[0]);
        $('#modal-calendar .form-title').text('Aggiorna Evento');
        $('#modal-calendar .btn-backend').text('Aggiorna');

        if(response.result.reminders.overrides){
            for(let override of response.result.reminders.overrides){
                let flag_found = false;
                let unit_reminder = 1;
                for(let index = 0; index < timeUnits.length && !flag_found; index++) {
                    if(override.minutes % timeUnits[index] == 0){
                        flag_found = true;
                        unit_reminder = timeUnits[index];
                    }
                }
                $('[name="value_' + override.method + '_reminder"]').val(override.minutes / unit_reminder);
                $('[name="unit_' + override.method + '_reminder"]').val(unit_reminder);
            }
        }
        $('.btn-backend-delete').removeClass('d-none');
        $('#modal-calendar').removeClass('opacity-0');
    } catch (err) {
        console.log('Errore calendario',err);

        if (gapi.client.getToken() === null) {
            Cookies.set("gapi_token", "");
            maybeInitLogin('get-event', data);
        } else {
            Swal.fire({
                title: 'Si è verificato un problema',
                text: 'L\'evento selezionato è stato cancellato dal tuo calendario.',
                icon: 'error',
            });
            return
        }

        return;
    }
}
async function autocomplete(input_field_id) {
    await google.maps.importLibrary("places");
    if (google !== undefined){
        var autocomplete = new google.maps.places.Autocomplete( document.getElementById(input_field_id), {types: ['geocode']} );
        autocomplete.setFields(['address_component']);
        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();
        });
    }
}
function resetModalCalendar(){
    $('input[name="start_date"]').val('');
    $('input[name="end_date"]').val('');
    $('[name="event_id"]').val('');
    $('[name="task_id"]').val('');
    $('[name="move_id"]').val('');
    $('#modal-calendar').addClass('opacity-0');
    $('[name="toggle-type-event"]').attr('checked', false);
    $('.event-hangout-option').addClass('d-none');
    $('.event-location-option').removeClass('d-none');
    $('.container-list-attendees').html('');
    $('[name="attendee-email"]').val('');
    $('[name="value_email_reminder"]').val(10);
    $('[name="unit_email_reminder"]').val('');
    $('[name="value_popup_reminder"]').val(10);
    $('[name="unit_popup_reminder"]').val('');
    $('[name="summary"]').val('');
    $('[name="description"]').val('');
    $('[name="location"]').val('');
    $('.hangout-link').text('');
    $('.hangout-link').attr('href', '#');
    $('.hangout-link-container').addClass('d-none');
    $('.actions').removeClass('d-none').addClass('d-flex');
    $('.no-evento').removeClass('d-flex').addClass('d-none');
    $('.form-calendar-content').find('input').prop('readonly',false);
    $('.form-calendar-content').find('textarea').prop('readonly',false);
    $('.form-calendar-content').find('select').removeClass('disabled-select');
    $('.form-calendar-content').find('.switch').removeClass('disabled-select');
}
function resetModalEmail(){
    $('#modal-email').addClass('opacity-0');
}
function resetModalSms(){
    $('#modal-sms').addClass('opacity-0');
}
function insertEventMove(event_id, start, end, hangoutLink){
    if($('[name="task_id"]').val() == ''){ return 0;}

    var partecipanti_array = [];
    
    $('.attendee-email-elem span').each(function(){
        partecipanti_array.push($(this).text());
    });
    $.ajax({
        'method': 'POST',
        'url': '/ajax/create-move',
        'data': {
            'evento' : 1,
            'task-id': $('[name="task_id"]').val(),
            'event-id': event_id,
            'note': $('[name="summary"]').val(),
            'descrizione': $('[name="description"]').val(),
            'start': start,
            'end': end,
            'indirizzo': $('[name="location"]').val(),
            'meet_url':hangoutLink,
            'partecipanti':partecipanti_array.join('|'),
            'email_promemoria_valore': $('[name="value_email_reminder"]').val(),
            'email_promemoria_unita': $('[name="unit_email_reminder"]').val(),
            'popup_promemoria_valore': $('[name="value_popup_reminder"]').val(),
            'popup_promemoria_unita': $('[name="unit_popup_reminder"]').val(),
            'organizzatore': $('#organizzatore').val()
        },
        success: function(response){
            if(response.success){
                location.reload();
            } else {
                Swal.fire("Errore", "Errore durante l'inserimento della mossa", "warning");
            }
        },
        error: function(error){
            Swal.fire("Errore", "Errore durante l'inserimento della mossa", "error");
        }
    });
}
function updateEventMove(start, end, hangoutLink){
    if($('[name="move_id"]').val() == ''){ return 0;}
    var partecipanti_array = [];
    
    $('.attendee-email-elem span').each(function(){
        partecipanti_array.push($(this).text());
    });
    $.ajax({
        'method': 'POST',
        'url': '/ajax/edit-move',
        'data': {
            'evento' : '1',
            'id-move': $('[name="move_id"]').val(),
            'new-note': $('[name="summary"]').val(),
            'descrizione': $('[name="description"]').val(),
            'start': start,
            'end': end,
            'indirizzo': $('[name="location"]').val(),
            'meet_url':hangoutLink,
            'partecipanti':partecipanti_array.join('|'),
            'email_promemoria_valore': $('[name="value_email_reminder"]').val(),
            'email_promemoria_unita': $('[name="unit_email_reminder"]').val(),
            'popup_promemoria_valore': $('[name="value_popup_reminder"]').val(),
            'popup_promemoria_unita': $('[name="unit_popup_reminder"]').val(),
            'organizzatore': $('#organizzatore').val()
        },
        success: function(response){
            if(response.success){
                location.reload();
            } else {
                Swal.fire("Errore", "Errore durante l'aggiornamento della mossa", "warning");
            }
        },
        error: function(error){
            Swal.fire("Errore", "Errore durante l'aggiornamento della mossa", "error");
            
        }
    });
}
function cancelEventMove(eventId){
    $.ajax({
        'method': 'POST',
        'url': '/ajax/cancel-calendar-move',
        'data': {
            'id-event': eventId
        },
        success: function(response){
            if(response.success){
                location.reload();
            } else {
                Swal.fire("Errore", "Errore durante la cancellazione della mossa", "warning");
            }
        },
        error: function(error){
            Swal.fire("Errore", "Errore durante la cancellazione della mossa", "error");
        }
    });
}

async function getThreadMessage(messages){
    try{
        for(let elem of messages){
            let subject;
            let from;
            let to;
            for(let header of elem.payload.headers){
                if(header.name == 'To'){
                    to = header.value;
                }
                if(header.name == 'From'){
                    from = header.value;
                }
                if(header.name == 'Subject'){
                    subject = header.value;
                }
            }
            let html_snippet = '';
            let encoded = "N";
            if(elem.payload.parts){
                for(let part of elem.payload.parts){
                    if(part.mimeType == 'text/html'){
                        html_snippet = part.body.data;
                        encoded = "S";
                    }
                }
            }
            let snippet = html_snippet != '' ? html_snippet : elem.snippet;
            
            if($('[data-email-id="' +  elem.id + '"]').length == 0){
                let data = {
                    'thread-id': elem.threadId,
                    'email-id': elem.id,
                    'email_subject': subject,
                    'email_to': to,
                    'email_from': from,
                    'email_body': snippet,
                    'internal_date': elem.internalDate,
                    'encoded': encoded
                };

                $.ajax({
                    url: '/ajax/upload-msg',
                    method: 'POST',
                    data: data,
                    success: function(result){
                        if(result.success){
                            let replaced_html = result.html_snippet.replace('<div class="gmail_quote">', '<div class="manage-gmail-quote"><i class="fa-solid fa-ellipsis"></i></div><div class="gmail_quote">');
                            $('[data-thread-id="' + elem.threadId + '"] .email-list-container').append('<div class="single-msg mt-3" data-email-id="'+ elem.id +'"><div style="line-height: 1"><small>from: ' + from + '</small></div><div style="line-height: 1"><small>to: ' + to + '</small></div><div class="mt-2">' + replaced_html + '</div></div>');
                        }
                    }
                })
            }
        }
    } catch (err){
        console.log(err);
    }
}
function createThreadEmail(id, threadId, data){
    $.ajax({
        'method': 'POST',
        'url': '/ajax/create-move',
        'data': {
            'email' : 1,
            'note': data.subject,
            'email-id': id,
            'thread-id': threadId,
            'task-id': $('[name="email_task_id"]').val(),
            'email_subject': data.subject,
            'email_to': data.to,
            'email_from': data.from,
            'email_body': data.body,
            'internal_date': data.internalDate
        },
        success: function(response){
            if(response.success){
                location.reload();
            } else {
                $('.form-loader').addClass('d-none');
                Swal.fire("Errore", "Errore durante l'invio della email", "warning");
            }
        },
        error: function(error){
            $('.form-loader').addClass('d-none');
            Swal.fire("Errore", "Errore durante l'invio della email", "error");
        }
    });
}